import React from 'react'
import { DesktopDatePicker } from '@mui/x-date-pickers'
import EventIcon from 'components/material-symbol/icons/Event'
import {
  mergeDesktopDatePickerSlotProps,
  mergeDesktopDatePickerSlots,
} from './desktop-date-picker'

const DatePickerIcon = props => <EventIcon fill={0} {...props} />

const PgaKeyboardDatePicker = props => {
  const {
    id,
    label,
    value,
    onChange,
    format,
    error,
    helperText,
    disableFuture,
    fullWidth,
    placeholder,
    name,
    slotProps,
    slots,
    'data-testid': dataTestId,
    ...rest
  } = props

  return (
    <DesktopDatePicker
      label={label}
      value={value}
      format={format}
      onChange={onChange}
      disableFuture={disableFuture}
      dayOfWeekFormatter={day => `${day}`}
      closeOnSelect
      slots={mergeDesktopDatePickerSlots({
        openPickerIcon: DatePickerIcon,
        ...slots,
      })}
      slotProps={mergeDesktopDatePickerSlotProps({
        ...slotProps,
        textField: {
          id,
          error,
          helperText,
          fullWidth,
          placeholder,
          name,
          'data-testid': dataTestId,
          ...slotProps?.textField,
        },
      })}
      {...rest}
    />
  )
}

export default PgaKeyboardDatePicker
